import {
	rawApiClient,
	rawNapiClientWithRetry,
	rawNapiPhotoServiceClient,
} from './RawNapiClient'
import {
	type FileUploadRequest,
	type UserSearchResultV2,
	type FeatureFlagsResult,
	type OnboardedBuilderNetworkResponse,
	type SaveBNUserDto,
	type CreateBuilderNetworkUserResult,
	type UpdateBNUserDto,
	type GetSelectionListByNameResult,
} from './types'
import { type Config } from '@adsk/napi-config'

export default {
	getSearchData: async (
		searchTerm: string,
		apiVersion: string
	): Promise<UserSearchResultV2 | undefined> => {
		const processedSearchTerm = encodeURIComponent(searchTerm.trim())
		if (processedSearchTerm !== '') {
			return await rawNapiClientWithRetry.get(
				`${apiVersion}/search/user?q=${processedSearchTerm}`
			)
		}
	},
	getFeatureFlags: async (
		queryParams: Record<string, string>
	): Promise<FeatureFlagsResult | undefined> => {
		let url = 'feature-flags'
		const params = new URLSearchParams()
		for (const [key, value] of Object.entries(queryParams)) {
			params.append(key, value)
		}
		const queryString = params.toString()
		if (queryString !== undefined && queryString !== '') {
			url = `${url}?${queryString}`
		}
		return await rawNapiClientWithRetry.get(url, { cacheData: true })
	},
	getClientConfig: async (): Promise<Config> =>
		await rawNapiClientWithRetry.get(`client-config`, { cacheData: true }),
	uploadFile: async (
		payload: FileUploadRequest
	): Promise<{ signedUrl: string }> => {
		const formData = new FormData()
		const { binary, ...rest } = payload
		for (const [key, value] of Object.entries(rest)) {
			formData.append(key, value)
		}
		formData.append('file', binary, binary.name)
		return await rawNapiPhotoServiceClient
			.fetch(`v1/upload`, {
				method: 'POST',
				body: formData,
			})
			.then((response) => response as unknown as { signedUrl: string })
	},
	saveUserToBuildersNetwork: async (
		payload: SaveBNUserDto
	): Promise<CreateBuilderNetworkUserResult> =>
		await rawNapiClientWithRetry.post('v2/users', payload),
	isOnboardedToBuildersNetwork:
		async (): Promise<OnboardedBuilderNetworkResponse> =>
			await rawNapiClientWithRetry.get(
				`v2/user/is-onboarded-to-builders-network`
			),
	getUserMeProfileInfo: async (): Promise<OnboardedBuilderNetworkResponse> =>
		await rawNapiClientWithRetry.get(`v2/users/@me`),
	updateUserProfile: async (
		payload: UpdateBNUserDto
	): Promise<OnboardedBuilderNetworkResponse> =>
		await rawNapiClientWithRetry.put(`v2/users`, payload),
	getSelectionListByName: async (
		name: string
	): Promise<GetSelectionListByNameResult[]> =>
		await rawNapiClientWithRetry.get(`v2/options/${name}`, { cacheData: true }),
	getServiceAreaByOfficeId: async (officeId: string): Promise<string[]> =>
		await rawNapiClientWithRetry.get(`v2/service-area/${officeId}`),
	fetchLookupTables: async (S3Url: string): Promise<any> =>
		await rawApiClient
			.get(S3Url)
			.then((response) => response as unknown as any),
}
